import React, { useContext, useEffect, useState } from "react";
import { useContentRepoFetch } from "../../../../libs/data-access/src/ContentRepository/useContentRepoFetch";
import { showToast } from "../../../../utils/utility";
import { AppContext } from "../../../../AppContext";
import { handleValidContentCategory } from "../../../../utils/validators";

const useContentCategory = () => {
    const DEFAULT_ITEMS_PER_PAGE = 8;
  const { role, user } = useContext(AppContext);
  const { fetchContentRepoData, postContentRepoData } = useContentRepoFetch();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [contentCategoryData, setContentCategoryData] = useState<any[]>([
    {
      category_Name: "Maths",
      category_Description: "Maths Content",
      created_on: "2023-10-01",
    },
    {
      category_Name: "Science",
      category_Description: "Science Content",
      created_on: "2023-10-02",
    },
    {
      category_Name: "English",
      category_Description: "English Content",
      created_on: "2023-10-03",
    },
  ]);
  const [contentCategoryAllData, setContentCategoryAllData] = useState<any[]>([]);
  const [contentCategoryDetails, setContentCategoryDetails] = useState<any>({
    category_Name: "",
    category_Description: "",
    user_Id: user?.role_Id,
  });

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);

  const [totalRecords, setTotalRecords] = useState(10);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmPayload, setConfirmPayload] = useState<any>(null);

  const nextPage = () => setCurrentPage(currentPage + 1);
  const prevPage = () => setCurrentPage(currentPage - 1);
   const [search, setSearch] = useState("");

  const handleChangeCategory = ({
    name,
    value,
  }: {
    name: string;
    value: any;
  }) => {
    setContentCategoryDetails((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getContentDataApi = async (current?: any) => {
    setLoading(true);
    // const res = await fetchContentRepoData(
    //   `GetContentRepositoryCategoryMaster/${
    //     currentPage * itemsPerPage
    //   }/${itemsPerPage}`
    // );
    const res = await fetchContentRepoData(
      `GetContentRepositoryCategoryMaster`
    );
    if (res.isSuccess) {
      setCurrentPage(0);
      setContentCategoryAllData(res?.data);
      setItemsPerPage(DEFAULT_ITEMS_PER_PAGE);
      let data = res?.data?.slice(
        0,
        itemsPerPage
      );
      setContentCategoryData(data);
      setTotalRecords(res?.data[0]?.total);
    } else {
      setContentCategoryAllData([]);
      setContentCategoryData([]);
      showToast({
        type: "error",
        message: res.message || "Something went wrong",
      });
    }

    setLoading(false);
  };

  const saveContentCategory = async ({ type, status, id }: any) => {
    let payload = {
      ...contentCategoryDetails,
      content_Category_Id: id
        ? id
        : contentCategoryDetails?.content_Category_Id
        ? contentCategoryDetails?.content_Category_Id
        : 0,
      is_Edit:
        type === "insert"
          ? 1
          : type === "Update"
          ? 2
          : type === "delete"
          ? 3
          : 0,
      is_active: status === "active" ? 1 : 0,
    };
    let valid;
    if (id) {
      valid = true;
    } else {
      valid = handleValidContentCategory(contentCategoryDetails);
    }
    if (valid) {
      const res = await postContentRepoData(
        `AddUpdateDeleteContentRepositoryCategoryMaster`,
        payload
      );
      if (res.isSuccess) {
        showToast({
          type: "success",
          message: res.message,
        });
        setContentCategoryDetails({
          category_Name: "",
          category_Description: "",
          user_Id: user?.role_Id,
        });

        getContentDataApi();
        setOpen(false);
      } else {
        showToast({
          type: "error",
          message: res.message,
        });
        // setContentCategoryDetails({
        //   category_Name: "",
        //   category_Description: "",
        //   user_Id: user?.role_Id,
        // });
      }
    }
  };

  const onchangeSingalContent = (id: any) => {
    let singalData = contentCategoryData?.find(
      (item: any) => item?.content_Category_Id === id
    );
    if (singalData) {
      setContentCategoryDetails({
        category_Name: singalData?.category_Name,
        category_Description: singalData?.category_Description,
        content_Category_Id: singalData?.content_Category_Id,
        user_Id: user?.role_Id,
      });
      setOpen(true);
    }
  };

  const onCloseModal = () => {
    setOpen(false);
    setContentCategoryDetails({
      category_Name: "",
      category_Description: "",
      user_Id: user?.role_Id,
    });
  };

  // Called when user toggles the switch -> open confirm modal
  const handleToggleRequest = (id: any, currentlyActive: boolean) => {
    const status = currentlyActive ? "inactive" : "active";
    setConfirmPayload({ id, status });
    setConfirmOpen(true);
  };

  // Confirm pressed -> call API via hook
  const handleConfirmToggle = async () => {
    if (!confirmPayload) return;
    // Use Update type for toggle (keeps parity with your hook)
    await saveContentCategory({
      type: "delete",
       status: confirmPayload?.status,
      id: confirmPayload?.id,
    });
    setConfirmOpen(false);
    setConfirmPayload(null);
  };

  const handleCancelToggle = () => {
    setConfirmOpen(false);
    setConfirmPayload(null);
  };

  useEffect(() => {
    getContentDataApi();
  }, []);

   useEffect(() => {
     if (search.trim()) {
       let filteredData = contentCategoryAllData.filter((item) =>
         item?.category_Name?.toLowerCase().includes(search.toLowerCase())
       );
       setTotalRecords(filteredData?.length);
       setItemsPerPage(filteredData?.length);
       setContentCategoryData(filteredData);
       return;
     }
     setTotalRecords(contentCategoryAllData?.length);
     setItemsPerPage(DEFAULT_ITEMS_PER_PAGE);
     let data = contentCategoryAllData?.slice(
       currentPage * DEFAULT_ITEMS_PER_PAGE,
       currentPage * DEFAULT_ITEMS_PER_PAGE + DEFAULT_ITEMS_PER_PAGE
     );
     setContentCategoryData(data);
   }, [search, contentCategoryAllData, currentPage]);

  //  useEffect(() => {
  //     let data = contentCategoryAllData?.slice(
  //       currentPage * itemsPerPage,
  //       currentPage * itemsPerPage + itemsPerPage
  //     );
  //     setContentCategoryData(data);
  //  }, [currentPage]);

  return {
    loading,
    contentCategoryDetails,
    contentCategoryData,
    open,
    setOpen,
    handleChangeCategory,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    totalRecords,
    prevPage,
    nextPage,
    saveContentCategory,
    onchangeSingalContent,
    onCloseModal,
    confirmOpen,
    setConfirmOpen,
    confirmPayload,
    setConfirmPayload,
    handleConfirmToggle,
    handleToggleRequest,
    handleCancelToggle,
    search,
    setSearch,
    contentCategoryAllData,
  };
};

export default useContentCategory;
